import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { SettingsProvider } from "@/context/SettingsContext";
import Layout from "@/components/Layout";
import HomePage from "@/pages/HomePage";
import SearchPage from "@/pages/SearchPage";
import DoctorProfilePage from "@/pages/DoctorProfilePage";
import DoctorRegistrationPage from "@/pages/DoctorRegistrationPage";
import PatientLoginPage from "@/pages/PatientLoginPage";
import PatientDashboardPage from "@/pages/PatientDashboardPage";
import AdminLoginPage from "@/pages/AdminLoginPage";
import AdminDashboardPage from "@/pages/AdminDashboardPage";
import SpecialtiesPage from "@/pages/SpecialtiesPage";
import CitiesPage from "@/pages/CitiesPage";
import { AboutPage, PrivacyPage, TermsPage, ContactPage } from "@/pages/StaticPages";

export default function App() {
  return (
    <AuthProvider>
      <SettingsProvider>
        <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<HomePage />} />

            {/* Doctor discovery routes (SEO-friendly) */}
            <Route path="/doctors/:city" element={<SearchPage />} />
            <Route path="/doctors/:city/:specialty" element={<SearchPage />} />
            <Route path="/doctors/:city/area/:area" element={<SearchPage />} />
            <Route path="/doctors/:city/area/:area/:specialty" element={<SearchPage />} />

            <Route path="/doctor/:slug" element={<DoctorProfilePage />} />

            <Route path="/specialties" element={<SpecialtiesPage />} />
            <Route path="/cities" element={<CitiesPage />} />

            <Route path="/list-your-practice" element={<DoctorRegistrationPage />} />

            <Route path="/patient/login" element={<PatientLoginPage />} />
            <Route path="/patient" element={<PatientDashboardPage />} />

            <Route path="/admin/login" element={<AdminLoginPage />} />
            <Route path="/admin" element={<AdminDashboardPage />} />

            <Route path="/about" element={<AboutPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/contact" element={<ContactPage />} />

            <Route
              path="*"
              element={
                <section className="mx-auto max-w-[600px] px-4 py-24 text-center">
                  <h1 className="font-display text-4xl font-bold">Page not found</h1>
                  <p className="text-muted-foreground mt-3">The page you're looking for doesn't exist.</p>
                  <a href="/" className="btn-primary mt-6 inline-flex">Back to home</a>
                </section>
              }
            />
          </Route>
        </Routes>
      </BrowserRouter>
      </SettingsProvider>
    </AuthProvider>
  );
}
